import {
    getProcessedDataFromDevice,
} from '../requests/processed'

import async from 'async';
import _ from 'lodash';

export const FETCH_DATA_FROM_NODES = 'FETCH_DATA_FROM_NODES';
export const LOADING = 'LOADING';
export const ERROR_REQ = 'ERROR_REQ';
export const NO_DATA = 'NO_DATA';
export const SET_DATE = 'SET_FROM';
export const REMOVE_ERRORS = 'REMOVE_ERRORS';
export const CHANGE_MIN_MAX = 'CHANGE_MIN_MAX';


export const fetchDataFromNode = (nodes, token, from, to, callback = false) => {
    return (dispatch) => {
        // dispatch(noData(false, nodes));
        // dispatch(removeErrors(true));
        // dispatch(setLoading(true));

        let batch = {
            CO: [],
            H2: [],
            NO: [],
            NO2:[],
            O3: [],
            PM_1: [],
            PM_10: [],
            PM_2P5: [],
            PRESSURE: [],
            R_HUMIDITY: [],
            SO2: [],
            TEMPERATURE: [],
            LABELS: ['Time']
        };

        // async.eachOf(nodes, (node, ind, cb) => {
        const syncFunt = (node, ind) => {
            getProcessedDataFromDevice(node, token, from, to, (resp, err) => {
                if (err) {
                    if (resp.status === 401)
                    // dispatch(setLoggedOutUser());TODO
                        null;
                    else {
                        // dispatch(noData(true, nodes));
                        // return setTimeout(() => {
                        //     dispatch(noData(false, nodes));
                        // }, 100)
                        // cb();
                    }
                } else {
                    // dispatch(setData(nodes, resp.data.data, Object.keys(resp.data.errors).map(node => {
                    //     return `${node} : ${resp.data.errors[node]}`;
                    // })));
                    // dispatch(setLoading(false));
                    // batch.push(resp.data);
                    let positives = ['CO', 'H2', 'NO', 'NO2', 'O3', 'PM_1', 'PM_10', 'PM_2P5'];

                    async.eachOf(resp.data, (value, key, cb2) => {
                        if (key === 'id' || key === 'type' || key === 'LAT' || key === 'LON')
                            cb2();
                        else if (ind === 0) {
                            async.each(value, (item, cb3) => {
                                let value = item.value;
                                if(positives.includes(key) && value < 0)
                                    value = null;
                                batch[key].push([new Date(item.modifiedAt), value]);
                                cb3();
                            }, err => {
                                if (err) console.log(err);
                                cb2();
                            });
                        } else {
                            async.eachOf(value, (item, indArr, cb3) => {
                                let value = item.value;
                                if(positives.includes(key) && value < 0)
                                    value = null;
                                batch[key][indArr].push(value);

                                cb3();
                            }, err => {
                                if (err) console.log(err);
                                cb2();
                            });
                        }
                    }, err => {
                        if (err) console.log(err);
                        batch.LABELS.push(node);
                        // cb();
                        if(ind === nodes.length - 1){
                            callback(batch, false);
                        } else {
                            syncFunt(nodes[ind + 1], ind + 1);
                        }
                    });
                }
            })
        };

        syncFunt(nodes[0], 0);

        // }, err => {
        //     if (err) console.log(err);
        //     callback(batch, false);
        // });
    }
};

const setLoading = (isLoading) => {
    return {
        type: LOADING,
        isLoading: isLoading
    }
};

const setData = (nodeID, data, errors) => {
    return {
        type: FETCH_DATA_FROM_NODES,
        data,
        errors,
        nodeID
    }
};

/**
 *
 * @param min {number}
 * @param max {number}
 * @returns {{type: string, min: *, max: *}}
 */
export const changeMinMaxSelector = (min, max) => {
    return {
        type: CHANGE_MIN_MAX,
        min,
        max
    }
};

const noData = (noData, nodesId) => {
    return {
        type: NO_DATA,
        noData,
        nodesId,
        errors: []
    }
};
export const removeErrors = (key) => {
    return {
        type: REMOVE_ERRORS,
        key
    }
};

export const setDate = (name, value) => {
    return {
        type: SET_DATE,
        name,
        value
    }
};



// WEBPACK FOOTER //
// ./src/actions/nodeCharts.js